import { createGlobalStyle } from "styled-components"

import settings from "./settings"

const GlobalStyle = createGlobalStyle`
  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}

  html, body {
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  html {
    height: 100%;
    
  }

  body {
    min-height: 100%;
    font-size: 22px;
    color: ${settings.color.default};
    font-family: ${settings.font.default};
    min-width: 320px;
  }
  
  *, :after, :before {
    box-sizing: border-box;
    outline: none;
  }
  
  table {
    border-collapse: collapse;
  }
  
  img {
    max-width: 100%;
    height: auto;
    vertical-align: top;
  }
  
  
  //Typography
  a {
    color: inherit;
    text-decoration: none;
  }

  mega {
    font-family: ${settings.font.headings};
    color: ${settings.color.primary_1};
    font-size: 80px;
    letter-spacing: -1px;
    line-height: 110%;
  }
  
  h1 {
    font-family: ${settings.font.headings};
    color: ${settings.color.primary_1};
    font-size: 56px;
    letter-spacing: -1px;
    line-height: 110%;
    font-weight: 400;
  }
    
  h2 {
    font-family: ${settings.font.headings};
    color: ${settings.color.primary_1};
    font-size: 40px;
    line-height: 110%;
    font-weight: 400;
  }
    
  h3 {
    font-family: ${settings.font.headings};
    color: ${settings.color.primary_1};
    font-size: 32px;
    line-height: 110%;
    font-weight: 400;
  }
    
  h4 {
    font-family: ${settings.font.headings};
    color: ${settings.color.primary_1};
    font-size: 24px;
    line-height: 110%;
    font-weight: 400;
  }
    
  h5 {
    font-family: ${settings.font.default};
    font-weight: 700;
    color: ${settings.color.primary_1};
    font-size: 18px;
    line-height: 120%;
  }

  pxl {
    font-family: ${settings.font.default};
    color: ${settings.color.primary_1};
    font-size: 22px;
    line-height: 130%;
    font-weight: 400;
  }

  p {
    font-family: ${settings.font.default};
    color: ${settings.color.primary_1};
    font-size: 18px;
    line-height: 130%;
    font-weight: 400;
  }

  //End Typography
  
  
  //Helpers
  .only-mobile {
    @media (min-width: ${settings.bp.medium.view}) {
      display: none;
    }
  }
  
  .only-desktop {
    @media (max-width: calc(${settings.bp.small.view} - 1px)) {
      display: none; 
    }
  }
  //END Helpers
  .ch2-btn {
    box-shadow: none !important;
  }

  .ch2-style-light .ch2-btn-primary:hover {
    background: #3c8dcf !important;
  }

  .ch2-style-light .ch2-btn-secondary {
    background: transparent !important;
    color: #5da7eb !important;
    border: solid 1px #5da7eb !important;
    box-shadow: none !important;
  }

  .ch2-style-light .ch2-btn-secondary:hover {
    background: transparent !important;
    color: #3c8dcf !important;
    border: solid 1px #3c8dcf !important;
    box-shadow: none !important;
  }
`

export default GlobalStyle
